{
  "ordersInfo": {
    "status": {
      "new": "Новый",
      "partially_filled": "Частично",
      "filled": "Исполнен",
      "done_for_day": "Завершен на сегодня",
      "canceled": "Отменен",
      "expired": "Истек",
      "replaced": "Заменен",
      "pending_cancel": "Ожидает отмены",
      "pending_replace": "Ожидает замены",
      "accepted": "В обработке",
      "pending_new": "Ожидает создания",
      "rejected": "Отклонен",
      "calculated": "Вычисляется",
      "accepted_for_bidding": "Принят на торги",
      "stopped": "Остановлен",
      "suspended": "Приостановлен",
      "held": "Ожидает"
    },
    "orderHints": {
      "bracket": {
        "main": {
          "title": "Ордер А",
          "helpText": "Если ордер А исполнится, тогда будут выставлены ордера B и С"
        },
        "secondary": [
          {
            "title": "Ордер B",
            "helpText": "Если ордер B исполнится, тогда ордер C будет отменён"
          },
          {
            "title": "Ордер C",
            "helpText": "Если ордер С исполнится, тогда ордер B будет отменён"
          }
        ]
      },
      "oto": {
        "main": {
          "title": "Ордер А",
          "helpText": "Если ордер А исполнится, тогда будет выставлен ордер B"
        },
        "secondary": [
          {
            "title": "Ордер B"
          }
        ]
      },
      "oco": {
        "main": {
          "title": "Ордер А",
          "helpText": "Если ордер А исполнится, тогда ордер B будет отменён"
        },
        "secondary": [
          {
            "title": "Ордер B",
            "helpText": "Если ордер B исполнится, тогда ордер А будет отменён"
          }
        ]
      }
    }
  }
}
